var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgGreenTick = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 17,
  height: 13,
  viewBox: "0 0 17 13",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M5.70711 9.29289L15 0L16.4142 1.41421L5.70711 12.1213L0 6.41421L1.41421 5L5.70711 9.29289Z",
  fill: "#02CA79"
})));
export { SvgGreenTick as ReactComponent };
export default __webpack_public_path__ + "74c6d1c1a9fbb0e231a20924548548f5.svg";